//importaciones
import { createApp } from 'vue'
import mitt from 'mitt'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import GAuth from 'vue3-google-login'
import Vue3Lottie from 'vue3-lottie'
import './styles/fonts.css'

// Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import "@mdi/font/css/materialdesignicons.css"
import 'material-design-icons-iconfont/dist/material-design-icons.css'

const vuetify = createVuetify({
    components,
    directives,
})
const emitter = mitt()

//inicio de sesion con google
const gAuthOptions = { clientId: process.env.VUE_APP_CLIENT_ID || ''}

//inicializacion de la app
const app = createApp(App)
app.config.globalProperties.emitter = emitter
app.use(store).use(router).use(GAuth,gAuthOptions).use(Vue3Lottie).use(vuetify).mount('#app')